import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
    selector: 'tt-select-report',
    templateUrl: './select-report.component.html',
    styleUrls: ['./select-report.component.css'],
    standalone: false
})
export class SelectReportComponent implements OnInit {
    webPageName;

    argType;

    argValue;

    public itemsListReports: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.webPageName = this.stateService.getStateParams()['webpage_name'];
        this.argType = this.stateService.getStateParams()['argtype'];
        this.argValue = this.stateService.getStateParams()['argvalue'];
    }

    private async loadReports() {
        if (!!this.webPageName && !!this.argType && !!this.argValue) {
            this.itemsListReports = await this.datatask.Post(335, {
                webpage: this.webPageName,
                argtype: this.argType,
                argvalue: this.argValue
            });
        }
    }

    private async init() {
        this.loadReports();
    }

    ngOnInit() {
        this.init();
    }
}
